import { render, staticRenderFns } from "./a33.vue?vue&type=template&id=3f029f97&scoped=true&"
import script from "./a33.vue?vue&type=script&lang=js&"
export * from "./a33.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f029f97",
  null
  
)

export default component.exports